import React, { useEffect, useRef, useState } from 'react'
import './teams-form.styles.scss';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import ManageContentInformation from '../create-elements/blocks/information.component';
import ManageContentIconCropped from '../create-elements/blocks/icon.component';
import { useSelector } from 'react-redux';
import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';
import { UseCloudFunction } from '@/utils/firebase.utils';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import { RandomString } from '@/utils/randomString';
import PlayerSelectElement from '../create-elements/blocks/player-select-element.component';
import SelectedPlayers from '../create-elements/blocks/selected-players.component';
import { getCollectionFromDb, getUniqueDocumentFromDb } from '@/utils/getDataFromDb';
import useAnalytics from '@/utils/useAnalytics';
import { getOptimizedBlob } from '@/utils/getOptimizedBlob';
import { completePlayerData } from '@/components/PREVIEW/previewPlayers';

const TeamForm = ({
  gameData,
  gameElements,
  playerList
}) => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const membership = useSelector(state => state.userData.membership);
  const [formData, setFormData] = useState({})
  const [alertMessage, setAlertMessage] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState(null);
  const [existingDescription, setExistingDescription] = useState(null);
  const [clearEditor, setClearEditor] = useState(false);
  const [loading, setLoading] = useState(false);
  const { teamPath } = useParams();
  const { trackEvent, trackException } = useAnalytics();
  const dataRef = useRef();
  const approveRef = useRef();
  const navigate = useNavigate();
  const storage = getStorage();
  const location = useLocation();

  useEffect(() => {
    if (!teamPath || !gameData) { return; }
    console.log(teamPath);
    getTeamData();
    // console.log(playerList);
    // dataRef.current = Object.values(playerList).filter(p => p.path === teamPath)[0];
    // setFormData(dataRef.current);
    // if (dataRef.current.desc) {
    //     setExistingDescription(dataRef.current.desc);
    // }
  }, [teamPath, gameData])

  function getTeamData() {
    if (location.pathname.includes('/preview/manager/')) {
      const teamData = Object.values(completePlayerData).filter(p => p.path === teamPath)[0];
      setFormData(teamData);
      if (teamData.desc) {
        setExistingDescription(teamData.desc);
      }
      return;
    }
    getCollectionFromDb({
      "collection": `games/${gameData.gameId}/players`,
      "query1": {
        "key": "path",
        "condition": "==",
        "value": teamPath
      },
      "once": true,
      "callback": callback
    })
    function callback(data) {
      console.log(data);
      dataRef.current = { ...data }
      setFormData(dataRef.current);
      if (dataRef.current.desc) {
        setExistingDescription(dataRef.current.desc);
      }
    }
  }

  function saveData(key, value) {
    dataRef.current = { ...dataRef.current, ...{ [key]: value } };
    setFormData(dataRef.current);
  }

  function cancelCreate() {
    setConfirmMessage('Are you sure you want to cancel? All of your data will be lost.');
    approveRef.current = () => {
      dataRef.current = {};
      setFormData(dataRef.current);
      navigate(-1)
    }
  }

  async function handleSubmit() {
    if (location.pathname.includes('/preview/manager/')) {
      setAlertMessage('Sorry! Data cannot be saved in Preview Mode.');
      return;
    }
    let tempData = { ...dataRef.current }
    const reqs = ['name', 'icon']
    for (let r of reqs) {
      if (!tempData[r]) {
        setAlertMessage('Please include a name and an icon for this Team before saving.');
        return;
      }
    }
    setConfirmMessage('Are you sure you are ready to save this Team? All of these settings can be changed later.')
    approveRef.current = () => {
      finishApproval()
    }
  }

  async function finishApproval() {
    setLoading(true);
    let tempData = { ...dataRef.current }
    if (tempData.icon.upload) {
      // tempData.icon.croppie.result({
      // 	type:'blob',
      // 	size: {'width': 352, 'height': 352},
      //     quality: 0.7,
      // })
      // .then((blob) => {
      // 	uploadImage(tempData.icon, blob)
      // 	return;
      // })
      const optimizedBlob = await getOptimizedBlob(tempData.icon.croppie, 20);
      console.log('Cropped image size in KB:', optimizedBlob.size / 1024);
      uploadImage(tempData.icon, optimizedBlob);
    } else if (tempData.icon.url) {
      saveTeam(tempData.icon.url)
      return;
    } else if (tempData.icon) {
      saveTeam(tempData.icon)
      return;
    } else {
      setAlertMessage('Something went wrong with the icon. Please try using a different image.');
      setLoading(false);
      return;
    }
  }

  async function uploadImage(icon, blob) {
    const now = new Date().getTime();
    const path = `${userProfile.appId}/${now}-${icon.name}`;
    const iconRef = ref(storage, path);
    const metadata = {
      // contentType: icon.type,
      customMetadata: {
        appId: userProfile.appId,
        email: userProfile.email
      }
    };
    const snapshot = await uploadBytes(iconRef, blob, metadata);
    const url = await getDownloadURL(snapshot.ref);
    saveTeam(url);
    await UseCloudFunction(
      'saveToMyContent',
      {
        'gameId': gameData.gameId,
        'appId': userProfile.appId,
        'source': 'Team Icons',
        'category': 'Images',
        'cropped': true,
        'contentData': {
          'name': icon.name,
          'url': url,
          'type': 'image',
          'id': `${now}_${RandomString(10)}_image`
        },
      }
    )
    
    return;
  }

  function removePlayer(playerId) {
    let tempMembers = []
  }

  async function saveTeam(iconUrl) {
    let tempData = { ...dataRef.current }
    console.log(tempData);
    const now = new Date().getTime();
    const gameCode = gameData.gameId.substring(gameData.gameId.indexOf('-') - 5, gameData.gameId.indexOf('-') + 6)
    if (!tempData.playerId) {
      tempData.appId = RandomString(20) + "_team";
      tempData.gameId = gameData.gameId;
      tempData.points = 0;
      tempData.playerId = gameData.gameId + "_" + tempData.appId;
      tempData.status = 'active';
      tempData.team = true;
      tempData.path = RandomString(18, 'abcdefghijkmnopqrstuvwxyz-_023456789');
    }
    tempData.opt_activeMemberCount =
      tempData.opt_members
        ? Object.values(playerList)
          .filter(p => tempData.opt_members.includes(p.playerId)).length
        : 0;
    tempData.displayName = tempData.name;
    tempData.fName = tempData.name;
    tempData.icon = iconUrl;
    console.log(tempData);
    const res = await UseCloudFunction(
      // 'savePlayerData', 
      // {
      //     'appId': userProfile.appId, 
      //     'dataList': {[tempData.playerId]: tempData}, 
      //     'gameId': gameData.gameId
      // }
      'saveTeamData',
      {
        'teamData': tempData,
        'appId': userProfile.appId,
        'gameId': gameData.gameId,
        'userName': `${userProfile.fName} ${userProfile.lName}`
      }
    )
    console.log(res);
    if (res.error) {
      setAlertMessage('Something went wrong. Please try again later. Error: ' + res.error);
      setLoading(false);
      trackException('Error saving team: ' + res.error);
      return;
    }
    trackEvent(
      'team_saved',
      'Game Manager',
      `Saved team - ${tempData.playerId}`,
      null,
      membership
    )
    setAlertMessage('Team saved successfully.');
    dataRef.current = {};
    setFormData(dataRef.current);
    setLoading(false);
    navigate(-1);
  }

  return (
    <div className='create-team-form'>
      <ManageContentInformation
        type='team'
        saveData={saveData}
        formData={formData}
        existingDescription={existingDescription}
        clearEditor={clearEditor}
        setClearEditor={setClearEditor}
        textEditorLabel='Team Description (optional)'
      />
      <div className='g-space-2'></div>
      <ManageContentIconCropped
        type='team'
        saveData={saveData}
        formData={formData}
      />
      <div className='g-space-2'></div>
      <PlayerSelectElement
        formData={formData}
        saveData={saveData}
        playerList={playerList}
        gameElements={gameElements}
        team={true}
      />
      <div className='g-space-2'></div>
      <SelectedPlayers
        formData={formData}
        saveData={saveData}
        playerList={playerList}
        gameElements={gameElements}
        removePlayer={removePlayer}
      />
      <div className='g-space-1'></div>
      <span className='required'>* = Required</span>
      <div className='buttons'>
        {
          (loading)
            ?
            <>
              <button type='button' className='g-button'>Cancel</button>
              <button type='button' className='g-button'><ThreeDotsLoader /></button>
            </>
            :
            <>
              <button type='button' className='g-button' onClick={() => cancelCreate()}>Cancel</button>
              <button type='button' className='g-button submit-button' onClick={() => handleSubmit()}>Save Team</button>
            </>
        }
      </div>
      <ModalAlert show={alertMessage} cancel={() => setAlertMessage(null)} message={alertMessage} />
      <ModalConfirm show={confirmMessage} cancel={() => setConfirmMessage(null)} message={confirmMessage} onApprove={approveRef.current} />
    </div>
  )
}

export default TeamForm